/* @flow */
import { Link } from 'react-router';
import { HEADER_HEIGHT } from 'style/dimensions';
import { GDCLogo } from 'components/Theme';
import QuickSearchContainer from 'containers/QuickSearchContainer';
import UserDropdownContainer from 'containers/UserDropdownContainer';
import GDCAppsDropdown from 'components/GDCAppsDropdown';
import { ExternalLink } from 'components/Links';

import Row from 'components/UIKit/Flex/Row';

export default function NavigationBar(): React.Element {
  return (
    <Row
      className="no-print"
      style={{
        backgroundColor: '#fff',
        borderBottom: '1px solid #e5e5e5',
        height: `${HEADER_HEIGHT}rem`,
      }}
      >
      <Row style={{ flex: 1, order: 1 }}>
        <Link to="/"><GDCLogo style={{ height: `${HEADER_HEIGHT}rem` }} /></Link>
      </Row>
      <QuickSearchContainer />
      <Row
        style={{
          order: 3,
          flex: 1,
          alignItems: 'center',
          justifyContent: 'flex-end',
        }}
        >
        <ExternalLink
          style={{ whiteSpace: 'nowrap', padding: '0 .5rem' }}
          href="https://docs.gdc.cancer.gov/Data_Submission_Portal/Users_Guide/Checklist/"
          >
          User's Guide
        </ExternalLink>
        <UserDropdownContainer />
        <GDCAppsDropdown />
      </Row>
    </Row>
  );
}
